import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import BrandSelect from './BrandSelect';

/**
 * The footer row of a list table: page size, "Visar x av y", and the pager.
 * Rendered inside .ll-table-card so it reads as the table's last row.
 *
 * Lifted from the employee list (and, before that, the customers table) so
 * every list paginates the same way. The pager only shows when there is more
 * than one page.
 */
export default function TablePager({
    pageIndex,
    pageSize,
    total,
    shown,
    noun,
    // Count before search/filter, when narrowed; shows "(filtrerat från n)".
    unfilteredTotal,
    onPageChange,
    onPageSizeChange,
    sizes = [10, 20, 30, 50, 100],
}) {
    const pageCount = Math.max(1, Math.ceil(total / pageSize));
    const last = pageCount - 1;
    return (
        <div className="ll-table-card__footer">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div className="d-flex align-items-center gap-3">
                    <div style={{ minWidth: 130 }}>
                        <BrandSelect
                            name="pageSize"
                            value={pageSize}
                            options={sizes.map((s) => ({ value: s, label: `${s} per sida` }))}
                            onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        />
                    </div>
                    <span>
                        Visar {shown} av {total} {noun}
                        {unfilteredTotal !== undefined && unfilteredTotal !== total && ` (filtrerat från ${unfilteredTotal})`}
                    </span>
                </div>

                {pageCount > 1 && (
                    <div className="d-flex align-items-center gap-1">
                        <button type="button" className="ll-btn ll-btn--secondary ll-btn--sm" onClick={() => onPageChange(0)} disabled={pageIndex === 0} title="Första sidan" aria-label="Första sidan">
                            <ChevronsLeft />
                        </button>
                        <button type="button" className="ll-btn ll-btn--secondary ll-btn--sm" onClick={() => onPageChange(pageIndex - 1)} disabled={pageIndex === 0} title="Föregående sida" aria-label="Föregående sida">
                            <ChevronLeft />
                        </button>
                        <span className="px-2" style={{ color: '#374151', fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
                            Sida {pageIndex + 1} av {pageCount}
                        </span>
                        <button type="button" className="ll-btn ll-btn--secondary ll-btn--sm" onClick={() => onPageChange(pageIndex + 1)} disabled={pageIndex >= last} title="Nästa sida" aria-label="Nästa sida">
                            <ChevronRight />
                        </button>
                        <button type="button" className="ll-btn ll-btn--secondary ll-btn--sm" onClick={() => onPageChange(last)} disabled={pageIndex >= last} title="Sista sidan" aria-label="Sista sidan">
                            <ChevronsRight />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
